import React, { useState } from "react";

const FeedbackForm = ({ onSubmitted }) => {
  const [formData, setFormData] = useState({
    satisfaction: "",
    recommend: "",
    rating: 5,
    onTime: "",
    staffCourteous: "",
    listened: "",
    improvement: "",
    comments: "",
  });

  const [charCount, setCharCount] = useState(0);

  const handleChange = (e) => {
    const { name, value, type } = e.target;
    setFormData({
      ...formData,
      [name]: type === "range" ? parseInt(value, 10) : value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    await fetch(process.env.REACT_APP_SHEET_URL, {
      method: "POST",
      mode: "no-cors",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });

    onSubmitted();
  };

  return (
    <form onSubmit={handleSubmit}>
      <h1 className="form-title">Patient Feedback Form</h1>
      <div className="form-group">
        <label>Overall, how was your experience of our service today?</label>
        <div className="radio-group">
          {["Very good", "Good", "Neither good nor poor", "Poor", "Very poor", "Don’t know"].map((option) => (
            <label className="radio-option" key={option}>
              <input
                type="radio"
                name="satisfaction"
                value={option}
                required
                onChange={handleChange}
              />
              {option}
            </label>
          ))}
        </div>
      </div>

      <div className="form-group">
        <label>Would you recommend North Middlesex University Hospital to your friends and family?</label>
        <div className="radio-group">
          {["Yes", "No"].map((option) => (
            <label className="radio-option" key={option}>
              <input
                type="radio"
                name="recommend"
                value={option}
                required
                onChange={handleChange}
              />
              {option}
            </label>
          ))}
        </div>
      </div>

      <div className="form-group">
        <label>How would you rate our service? </label>
        {formData.rating}
        <input
          type="range"
          name="rating"
          min="0"
          max="10"
          value={formData.rating}
          onChange={handleChange}
        />
      </div>

      <div className="form-group">
        <label>Was your appointment on time?</label>
        <div className="radio-group">
          {["Yes", "No"].map((option) => (
            <label className="radio-option" key={option}>
              <input
                type="radio"
                name="onTime"
                value={option}
                required
                onChange={handleChange}
              />
              {option}
            </label>
          ))}
        </div>
      </div>

      <div className="form-group">
        <label>Was the staff courteous and professional?</label>
        <div className="radio-group">
          {["Yes", "No"].map((option) => (
            <label className="radio-option" key={option}>
              <input
                type="radio"
                name="staffCourteous"
                value={option}
                required
                onChange={handleChange}
              />
              {option}
            </label>
          ))}
        </div>
      </div>

      <div className="form-group">
        <label>Did you feel listened to and understood during your visit?</label>
        <div className="radio-group">
          {["Yes", "No"].map((option) => (
            <label className="radio-option" key={option}>
              <input
                type="radio"
                name="listened"
                value={option}
                required
                onChange={handleChange}
              />
              {option}
            </label>
          ))}
        </div>
      </div>

      <div className="form-group">
        <label>What could we improve?</label>
        <textarea
          name="improvement"
          required
          rows="3"
          onChange={handleChange}
        />
      </div>

      <div className="form-group">
        <label>Additional comments (optional):</label>
        <textarea
          name="comments"
          rows="3"
          maxLength={100}
          value={formData.comments}
          onChange={(e) => {
            handleChange(e);
            setCharCount(e.target.value.length);
          }}
        />
        <small>{charCount}/100 characters</small>
      </div>

      <button type="submit">Submit Feedback</button>
    </form>
  );
};

export default FeedbackForm;
